import axios from 'axios';

export default class EventService {
  static async getAll(id = null, start = null, end = null) {
    const response = await axios.get('/events', { params: { user: id, start: start, end: end } });
    return response.data.rows;
  }
}
